import * as types from './types';

export const createTimesheetRequest = (data) => ({ type: types.CREATE_TIMESHEET_REQUEST, data });
export const createTimesheetRequestFailure = (error) => ({ type: types.CREATE_TIMESHEET_REQUEST_FAILURE, error });
export const createTimesheetRequestSuccess = (data) => ({ type: types.CREATE_TIMESHEET_REQUEST_SUCCESS, data });

export const deleteTimesheetRequest = (data) => ({ type: types.DELETE_TIMESHEET_REQUEST, data });
export const deleteTimesheetRequestFailure = (error) => ({ type: types.DELETE_TIMESHEET_REQUEST_FAILURE, error });
export const deleteTimesheetRequestSuccess = (data) => ({ type: types.DELETE_TIMESHEET_REQUEST_SUCCESS, data });

export const duplicateTimesheetRequest = (data) => ({ type: types.DUPLICATE_TIMESHEET_REQUEST, data });
export const duplicateTimesheetRequestFailure = (error) => ({ type: types.DUPLICATE_TIMESHEET_REQUEST_FAILURE, error });
export const duplicateTimesheetRequestSuccess = (data) => ({ type: types.DUPLICATE_TIMESHEET_REQUEST_SUCCESS, data });

export const getTimesheetRequest = (data) => ({ type: types.GET_TIMESHEET_REQUEST, data });
export const getTimesheetRequestFailure = (error) => ({ type: types.GET_TIMESHEET_REQUEST_FAILURE, error });
export const getTimesheetRequestSuccess = (data) => ({ type: types.GET_TIMESHEET_REQUEST_SUCCESS, data });

export const recallTimesheetRequest = (data) => ({ type: types.RECALL_TIMESHEET_REQUEST, data });
export const recallTimesheetRequestFailure = (error) => ({ type: types.RECALL_TIMESHEET_REQUEST_FAILURE, error });
export const recallTimesheetRequestSuccess = (data) => ({ type: types.RECALL_TIMESHEET_REQUEST_SUCCESS, data });

export const resetTimesheetState = (data) => ({ type: types.RESET_TIMESHEET_STATE, data });

export const saveTimesheetRequestFailure = (error) => ({ type: types.SAVE_TIMESHEET_REQUEST_FAILURE, error });
export const saveTimesheetRequestSuccess = (data) => ({ type: types.SAVE_TIMESHEET_REQUEST_SUCCESS, data });

export const saveTimesheetRequestAsync = (data) => ({ type: types.SAVE_TIMESHEET_REQUEST_ASYNC, data });
export const saveTimesheetRequestAsyncFailure = (error) => ({ type: types.SAVE_TIMESHEET_REQUEST_ASYNC_FAILURE, error });
export const saveTimesheetRequestAsyncSuccess = (data) => ({ type: types.SAVE_TIMESHEET_REQUEST_ASYNC_SUCCESS, data });

export const submitTimesheetRequest = (data) => ({ type: types.SUBMIT_TIMESHEET_REQUEST, data });
export const submitTimesheetRequestFailure = (error) => ({ type: types.SUBMIT_TIMESHEET_REQUEST_FAILURE, error });
export const submitTimesheetRequestSuccess = (data) => ({ type: types.SUBMIT_TIMESHEET_REQUEST_SUCCESS, data });

export const submitTimesheetRequestAsync = (data) => ({ type: types.SUBMIT_TIMESHEET_REQUEST_ASYNC, data });
export const submitTimesheetRequestAsyncFailure = (error) => ({ type: types.SUBMIT_TIMESHEET_REQUEST_ASYNC_FAILURE, error });
export const submitTimesheetRequestAsyncSuccess = (data) => ({ type: types.SUBMIT_TIMESHEET_REQUEST_ASYNC_SUCCESS, data });

export const updateTimesheetRequest = (data) => ({ type: types.UPDATE_TIMESHEET_REQUEST, data });
export const updateTimesheetRequestFailure = (error) => ({ type: types.UPDATE_TIMESHEET_REQUEST_FAILURE, error });
export const updateTimesheetRequestSuccess = (data) => ({ type: types.UPDATE_TIMESHEET_REQUEST_SUCCESS, data });
